import { useOnboarding } from '../../../onboarding/hooks/useOnboarding';
import { SUPPORT_RESCUE_AFTER_ATTEMPTS } from '../failedAttempts';
import { readLinkingRescueArm } from './linkingExperiments';

/** El umbral del brazo de tratamiento: la salida a soporte aparece al primer
 * tropiezo en vez de al tercero. */
export const SUPPORT_RESCUE_TREATMENT_ATTEMPTS = 1;

/**
 * A partir de cuántos intentos fallidos aparece la salida a soporte.
 *
 * Lee el brazo ESTAMPADO en el record, nunca GrowthBook: la asignación la hizo
 * una sola vez `useLinkingExperiments` al abrir el flujo. Sin stamp (usuario sin
 * record, o que aún no ha fallado) devuelve el umbral de siempre, que es el
 * control.
 */
export const useSupportRescueThreshold = (): number => {
	const { data: record } = useOnboarding();
	return readLinkingRescueArm(record) === 'treatment'
		? SUPPORT_RESCUE_TREATMENT_ATTEMPTS
		: SUPPORT_RESCUE_AFTER_ATTEMPTS;
};

export default useSupportRescueThreshold;
